import { useMemo } from 'react';
import useAllDeviceItems from './useAllDeviceItems';

/**
 * Returns the set of pet GraphQL IDs for pets the current rescue has a
 * pending adoption transfer on (PENDING_ADOPTIONS). Used to gate destructive
 * chip mutations that the backend rejects mid-transfer — Remove from Pet in
 * particular fails server-side while a transfer is pending, so the UI hides
 * the action rather than letting the click 500 into an error toast.
 *
 * Same scope caveat as useAdoptedPetIds: backed by `rescueDevices`, so
 * chip-only pets (never had a GPS device) aren't represented.
 */
export default function usePendingAdoptionPetIds(): { pendingAdoptionPetIds: Set<string>; loading: boolean } {
  const { items, loading } = useAllDeviceItems('PENDING_ADOPTIONS');
  const pendingAdoptionPetIds = useMemo(() => new Set(items.map((item) => item.pet.id)), [items]);
  return { pendingAdoptionPetIds, loading };
}
